import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import useModel from '../hooks/use-model'

function WhenModel (props) {
  const model = useModel()

  if (props.exists === true) {
    if (!model || !model.size) {
      return null
    }
  }

  if (props.exists === false) {
    if (!(!model || !model.size)) {
      return null
    }
  }

  return props.children
}

WhenModel.defaultProps = {
  exists: true
}

WhenModel.propTypes = {
  exists: PropTypes.bool
}

export default observer(WhenModel)
